export const hotjarDomains: Record<string, number> = {
  'hml2.ilotto.com.br': 5352209,
  'premiosconceito.com.br': 5350107,
  'ouropix.com.br': 5361313,
};

export const getHotjarScript = (hotjarId: number): string => `
  (function(c,s,q,u,a,r,e){
    c.hj=c.hj||function(){(c.hj.q=c.hj.q||[]).push(arguments)};
    c._hjSettings={hjid:${hotjarId}};
    r=s.getElementsByTagName('head')[0];
    e=s.createElement('script');
    e.async=true;
    e.src=q+c._hjSettings.hjid+u;
    r.appendChild(e);
  })(window,document,'https://static.hj.contentsquare.net/c/csq-','.js');
`;
